import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { UserServerData } from "@/ts/interfaces/requests/user";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import { authMePath } from "@/ts/apiRoutes";

export const useAuthMeStore = defineStore('api-auth-me',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    const user = ref<UserServerData>({
        name: '',
        email: '',
        job_title: '',
        company: '',
        phone_number: '',
        meetings_link: '',
        email_notifications: true,
    })

    async function getUser() {
        status.value = RequestStatus.LOADING

        const response = await request(authMePath, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8',
            },
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS

            const data = await response.json()

            user.value = {
                ...data,
                email_notifications: !!data.email_notifications
            }
        }
    }

    return { status, user, getUser }
})